import { Language } from 'lipp-components';

import { TextTemplateDTO } from 'src/dtos/TextTemplateDTO';

import { EnTextTemplateTextType } from 'src/enums/EnTextTemplateTextType';
import { EnTextTemplateType } from 'src/enums/EnTextTemplateType';
import { EnTextTemplateNotificationType } from 'src/enums/EnTextTemplateNotificationType';
import { EnTextTemplateNotificationRecipientType } from 'src/enums/EnTextTemplateNotificationRecipientType';

export class TextTemplate {
  public id!: number;
  public language!: Language;
  public identifier!: string;
  public name!: string;
  public description!: string;
  public text!: string;
  public type!: EnTextTemplateType;
  public textType!: EnTextTemplateTextType;
  public stationId?: number;
  public isLineckerInternal!: boolean;
  public sendNotification!: boolean;
  public canDefineNotificationSending!: boolean;
  public notificationType!: EnTextTemplateNotificationType;
  public notificationRecipientType!: EnTextTemplateNotificationRecipientType;

  constructor(dto: TextTemplateDTO) {
    this.id = dto.id;
    this.language = dto.culture;
    this.identifier = dto.identifierName;
    this.name = dto.name;
    this.description = dto.description;
    this.type = dto.type;
    this.textType = dto.textType;
    this.stationId = dto.stationId;
    this.isLineckerInternal = dto.isLineckerInternal;
    this.sendNotification = dto.sendNotification;
    this.canDefineNotificationSending = dto.canDefineNotificationSending;
    this.notificationType = dto.notificationType;
    this.notificationRecipientType = dto.notificationRecipientType;

    if (this.textType == EnTextTemplateTextType.PlainText) {
      this.text = dto.text.replace(/\n/g, '<br>');
    } else {
      this.text = dto.text;
    }
  }
}
